export const ShareholderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_shareholder_pie)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23984 2.22729 1.21446 3.47672 0.608962 4.93853C0.00346089 6.40034 -0.154966 8.00888 0.153716 9.56072C0.462398 11.1126 1.22432 12.538 2.34314 13.6569C3.46196 14.7757 4.88743 15.5376 6.43928 15.8463C7.99112 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM14.6327 7.33333H8.66667V1.36733C10.1959 1.52304 11.6245 2.20163 12.7115 3.28854C13.7984 4.37545 14.477 5.80411 14.6327 7.33333V7.33333ZM1.33333 8C1.33541 6.34797 1.95002 4.75539 3.0583 3.53025C4.16657 2.30512 5.68977 1.53447 7.33333 1.36733V8.276L12.216 13.1587C11.2399 13.9583 10.0567 14.4642 8.80428 14.6176C7.55182 14.771 6.28156 14.5654 5.14136 14.0249C4.00116 13.4845 3.03792 12.6312 2.36376 11.5646C1.6896 10.498 1.33226 9.26182 1.33333 8V8ZM13.1587 12.216L9.60933 8.66667H14.6327C14.5027 9.96939 13.9898 11.2044 13.1587 12.216Z"
          fill="#A09CAD"
        />
      </g>
      <defs>
        <clipPath id="clip0_shareholder_pie">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
